import request from '@/axios/request.js'

// 获取首页内容
export function getIndexPageList () {
    return request({
        url: '/mall/shopindex/index',
        method: 'get'
    })
}

// 热门搜索关键字获取
export function getKeyWord () {
    return request({
        url: '/mall/shopindex/search/keyword',
        method: 'get'
    })
}
// 获取商品列表
export function getProductsBySku(params) {
  return request({
    url: '/mall/getSkuProductList',
    method: 'get',
    params
  })
}

// 获取商品列表
export function getProducts (params) {

    return request({
        url: '/mall/products',
      // url: '/mall/productsByCateId',
        method: 'get',
        params
    })
}


// 普通商品详情
export function getNormalProductDetail (id) {
    return request({
        url: `/mall/product/detail/${id}`,
        method: 'get'
    })
}

// 商品详情海报
export function getProductPoster (id, params) {
    return request({
        url: `/mall/product/poster/${id}`,
        method: 'get',
        params
    })
}

// 获取分类id
export function getCategory () {
    return request({
        url: '/mall/category',
        method: 'get'
    })
}

// 热门推荐
export function getHotProduct () {
    return request({
        url: '/mall/product/hot',
        method: 'get'
    })
}

export function getCanvasData (params) {
    return request({
        url: '/mall/shopindex/getCanvas',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/indexpage.js